// Shared labels/formatting for the Lavados pages and report. Wash times are
// real UTC timestamps from the device; show them in Mexico City time.
import React from "react";
import { Badge } from "@shopify/polaris";

export const LEVEL_LABELS = {
  regular: "Regular",
  profundo: "Profundo",
  motor: "Motor",
};
export const levelsText = (levels) => (levels || []).map((l) => LEVEL_LABELS[l] || l).join(" + ");

export const STATUS = {
  open: { label: "En curso", tone: "info" },
  cancelled: { label: "Descartado", tone: undefined },
  pending_ai: { label: "Calificando", tone: undefined },
  auto_approved: { label: "Aprobado (IA)", tone: "success" },
  flagged: { label: "Por revisar", tone: "warning" },
  approved: { label: "Aprobado", tone: "success" },
  rejected: { label: "Rechazado", tone: "critical" },
};
export const StatusBadge = ({ status }) => (
  <Badge tone={STATUS[status]?.tone}>{STATUS[status]?.label || status}</Badge>
);

// Statuses that count for the washer's pay.
export const PAID_STATUSES = ["auto_approved", "approved"];

export const fmtMoney = (v) => "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");

export const fmtDateTime = (ts) =>
  ts
    ? new Date(ts).toLocaleString("es-MX", {
        timeZone: "America/Mexico_City",
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

export const mxDate = (ts) =>
  ts ? new Date(ts).toLocaleDateString("en-CA", { timeZone: "America/Mexico_City" }) : "";

// Same order the app photographs them in (inspection-ipad src/lib/washSteps.js).
export const SLOTS = [
  ["frente", "Frente"],
  ["costado_derecho", "Costado derecho"],
  ["atras", "Atrás"],
  ["costado_izquierdo", "Costado izquierdo"],
  ["asientos_delanteros", "Asientos delanteros"],
  ["asientos_traseros", "Asientos traseros"],
  ["tablero", "Tablero y consola"],
  ["cajuela", "Cajuela"],
  ["asiento_conductor", "Asiento conductor"],
  ["asiento_copiloto", "Asiento copiloto"],
  ["asientos_traseros_cerca", "Asientos traseros (de cerca)"],
  ["alfombras", "Alfombras"],
  ["motor", "Motor"],
];
